import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { Response } from '@frontend/sorghum/interface';
import { FLOW_GROUP_INDEX } from '../apis';
import { toast } from 'react-toastify';
import { queryClient } from '@frontend/sorghum/external-providers';

async function patchEditorFlowGroup(props: Props): Promise<Response> {
  return axios
    .patch(`${FLOW_GROUP_INDEX}?projectId=${props.projectId}`, {
      flowGroups: props.flowGroups,
    })
    .then((res) => res.data)
    .catch((err) => ({
      code: 400,
      msg: err,
    }));
}

interface Props {
  projectId: string;
  flowGroups: string[];
}

export function usePatchEditorFlowGroupIndex() {
  return useMutation({
    mutationKey: ['patch-editor-flow-group-index'],
    mutationFn: (props: Props) => patchEditorFlowGroup(props),
    onSuccess: (data) => {
      if (data.code === 20000) {
        queryClient.refetchQueries(['editor-flow-group']);
        toast.success(data.msg);
      } else {
        toast.warn(data.msg);
      }
    },
  });
}

export default usePatchEditorFlowGroupIndex;
